import { useState } from 'react';

interface AthleteAvatarProps {
  firstName: string;
  lastName: string | null;
  imageUrl: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'size-10 text-sm',
  md: 'size-16 text-lg',
  lg: 'size-32 text-3xl sm:size-40',
};

export function AthleteAvatar({
  firstName,
  lastName,
  imageUrl,
  size = 'md',
  className = '',
}: AthleteAvatarProps) {
  const [hasImageError, setHasImageError] = useState(false);
  const displayName = [firstName, lastName].filter(Boolean).join(' ');
  const initials = `${firstName.at(0) ?? ''}${lastName?.at(0) ?? ''}`.toUpperCase();
  const classes = `${sizeClasses[size]} shrink-0 overflow-hidden rounded-full bg-gradient-to-br from-indigo-100 to-violet-200 font-black text-qs-navy ring-4 ring-white shadow-md ${className}`;

  if (!imageUrl || hasImageError) {
    return (
      <span className={`grid place-items-center ${classes}`} aria-label={displayName}>
        {initials}
      </span>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={displayName}
      className={`${classes} object-cover`}
      onError={() => setHasImageError(true)}
    />
  );
}
